/** Сигнал потери API-авторизации (401) — UI не должен показывать «живой» shell без данных. */

export const API_AUTH_LOST_EVENT = 'algosys:api-auth-lost';
export const API_AUTH_RESTORED_EVENT = 'algosys:api-auth-restored';

let apiAuthLost = false;

export function markApiAuthLost(): void {
  if (apiAuthLost) return;
  apiAuthLost = true;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(API_AUTH_LOST_EVENT));
  }
}

export function isApiAuthLost(): boolean {
  return apiAuthLost;
}

export function clearApiAuthLost(): void {
  if (!apiAuthLost) return;
  apiAuthLost = false;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(API_AUTH_RESTORED_EVENT));
  }
}
